module.exports = __webpack_public_path__ + "img/logo-ha.057d39cb.svg";